<div class="factura-container">
    <mat-card class="rounded-0 border">
        <mat-card-title>
            <h2 class="color-blue-cat">Comprobante de pago</h2>
        </mat-card-title>
        <mat-card-content>
            <form>
                <!-- Select para el concepto de pago -->
                <mat-form-field class="full-width">
                    <mat-label>Concepto</mat-label>
                    <mat-select [(ngModel)]="selectedConcepto" name="concepto" (change)="onConceptoChange()">
                        <mat-option *ngFor="let concepto of productos" [value]="concepto.idProducto">
                            {{ concepto.descripcion }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- Select para el precio según el concepto seleccionado -->
                <mat-form-field class="full-width">
                    <mat-label>Precio</mat-label>
                    <mat-select [(ngModel)]="selectedPrecio" name="precio" (change)="onConceptoChange()">
                        <mat-option *ngFor="let concepto of productos" [value]="concepto.precioSocio">
                            Precio a Socio | {{ concepto.precioSocio | currency:'MXN' }}
                        </mat-option>
                        <mat-option *ngFor="let concepto of productos" [value]="concepto.precioEstudiante">
                            Precio a Estudiante | {{ concepto.precioEstudiante | currency:'MXN' }}
                        </mat-option>
                        <mat-option *ngFor="let concepto of productos" [value]="concepto.precioPublico">
                            Precio al Público en General | {{ concepto.precioPublico | currency:'MXN' }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>

            <div class="text-right">
                <button (click)="onUploadClick()" class="btn-blue-cat">Subir archivo</button>
            </div>
        </mat-card-content>
    </mat-card>
</div>
